// extracted by mini-css-extract-plugin
export default {"root":"Panel2_root_B6hqn"};